export default "__VITE_ASSET__SWs3dWnj__"